import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import UnAuthenticatedLayout from './UnAuthenticatedLayout';
import Flag from '../Flag';
import AddToFavorites from '../AddToFavorites/AddToFavorites';

class Chrome extends Component {
  constructor(props) {
    super(props);
    const { location } = props;
    this.state = {
      activity: { pathName: location.pathname },
      AuthenticatedLayout: null,
      SessionActivity: null,
    };
    this.handleExpired = this.handleExpired.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
  }

  componentDidMount() {
    this.setupListener();
  }

  componentWillUnmount() {
    if (this.unlisten) {
      this.unlisten();
    }
  }

  setupListener() {
    const { history } = this.props;
    this.unlisten = history.listen(location => {
      const { isPathLevelRedirect } = location.state || {};
      if (!isPathLevelRedirect) {
        this.setState({ activity: { pathName: location.pathname } });
      }
    });
  }

  handleExpired() {
    const { updateSession } = this.props;
    updateSession(null);
  }

  handleUpdate(data) {
    const { activity } = this.state;
    const { updateSession } = this.props;
    if (activity) {
      updateSession(data);
    }
  }

  renderAuthedLayout() {
    const {
      children,
      createdAt,
      didSet,
      firstName,
      hasSubscription,
      markCompleteModalData,
      isVisible,
      isFavoritesEnabled,
      searchQuery,
      sessionData,
      sessionLengthInMins,
      setMarkCompleteModal,
      showStreaksModal,
      updateLessonCompletedProgress,
      history,
      location,
    } = this.props;
    const { activity, AuthenticatedLayout, SessionActivity } = this.state;
    if (!AuthenticatedLayout) {
      Promise.all([
        import(
          /* webpackChunkName: "AuthenticatedLayout" */ '@fenderdigital/react-session-activity'
        ),
        import(/* webpackChunkName: "AuthenticatedLayout" */ './AuthenticatedLayout'),
      ]).then(([sessMod, authMod]) => {
        this.setState({
          SessionActivity: sessMod.default,
          AuthenticatedLayout: authMod.default,
        });
      });
      return null;
    }
    return (
      <SessionActivity
        {...sessionData}
        activity={activity}
        lengthOfSession={sessionLengthInMins}
        onStart={this.handleUpdate}
        onExpired={this.handleExpired}
        onUpdate={this.handleUpdate}
      >
        <AuthenticatedLayout
          history={history}
          firstName={firstName}
          hasSubscription={hasSubscription}
          pathName={location.pathname}
          isFavoritesEnabled={isFavoritesEnabled}
          searchQuery={searchQuery}
          createdAt={createdAt}
          showStreaksModal={showStreaksModal}
          markCompleteModalData={markCompleteModalData}
          updateLessonCompletedProgress={updateLessonCompletedProgress}
          setMarkCompleteModal={setMarkCompleteModal}
        >
          {children}
        </AuthenticatedLayout>
        <Flag name="isFavoritesEnabled">
          {isVisible ? <AddToFavorites didSet={didSet} /> : null}
        </Flag>
      </SessionActivity>
    );
  }

  renderUnAuthedLayout() {
    const { firstName, children, messages, searchQuery, sessionCheckComplete } = this.props;
    return (
      <UnAuthenticatedLayout
        firstName={firstName}
        messages={messages}
        searchQuery={searchQuery}
        sessionCheckComplete={sessionCheckComplete}
      >
        {children}
      </UnAuthenticatedLayout>
    );
  }

  render() {
    const { loggedIn, hasSubscription } = this.props;
    if (loggedIn && hasSubscription) {
      return this.renderAuthedLayout();
    }
    return this.renderUnAuthedLayout();
  }
}

Chrome.propTypes = {
  history: PropTypes.shape({ listen: PropTypes.func.isRequired }).isRequired,
  children: PropTypes.node,
  createdAt: PropTypes.string,
  didSet: PropTypes.bool.isRequired,
  firstName: PropTypes.string,
  hasSubscription: PropTypes.bool,
  loggedIn: PropTypes.bool,
  markCompleteModalData: PropTypes.shape({}),
  messages: PropTypes.shape({}),
  isVisible: PropTypes.bool.isRequired,
  isFavoritesEnabled: PropTypes.bool.isRequired,
  searchQuery: PropTypes.string,
  sessionCheckComplete: PropTypes.bool,
  sessionData: PropTypes.shape({}),
  sessionId: PropTypes.string,
  sessionLengthInMins: PropTypes.number,
  setMarkCompleteModal: PropTypes.func,
  showStreaksModal: PropTypes.func,
  subscriptions: PropTypes.shape({}).isRequired,
  updateLessonCompletedProgress: PropTypes.func,
  updateSession: PropTypes.func,
  userID: PropTypes.string,
};

Chrome.defaultProps = {
  children: null,
  createdAt: '',
  firstName: null,
  hasSubscription: null,
  loggedIn: null,
  markCompleteModalData: null,
  messages: null,
  searchQuery: '',
  sessionCheckComplete: null,
  sessionData: null,
  sessionId: null,
  sessionLengthInMins: null,
  setMarkCompleteModal: () => {},
  showStreaksModal: () => {},
  updateLessonCompletedProgress: () => {},
  updateSession: () => {},
  userID: null,
};

export default withRouter(Chrome);
